<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Charity</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <b>Charity</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <router-link :to="{ name: 'charity-add' }" type="button" class="btn btn-primary mb-2">Add</router-link>
      </div>

      <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button class="btn btn-secondary" id="btn-active" :class="{ 'change-background': activeClick }" type="button"
            @click="insertActive()">
            Active
          </button>
          <button class="btn btn-secondary" id="btn-inactive" :class="{ 'change-background': inactiveClick }"
            type="button" @click="insertInactive()">
            Inactive
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">{{ tableTitle }}</h4>

            <div class="d-flex flex-row flex-wrap mb-5 _filterClass">
              <div class="flex-grow-1 d-flex flex-column mr-2">
                <label><b>Period From</b></label>
                <div class="d-flex flex-row">
                  <select class="form-control" v-model="filterData.month_from" required>
                    <option value="">Select Month</option>
                    <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}</option>
                  </select>

                  <input type="number" class="form-control" v-model="filterData.year_from" required />
                </div>
              </div>

              <div class="flex-grow-1 d-flex flex-column mr-2">
                <label><b>Period To</b></label>
                <div class="d-flex flex-row">
                  <select class="form-control" v-model="filterData.month_to" required>
                    <option value="">Select Month</option>
                    <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}</option>
                  </select>

                  <input type="number" class="form-control" v-model="filterData.year_to" required />
                </div>
              </div>

              <div class="flex-shrink-1 filter-buttons mr-2">
                <div class="d-flex flex-row">
                  <button class="btn btn-rounded btn-primary mr-2" style="width: 150px;" @click="filterPeriod">
                    Filter
                  </button>
                  <button class="btn btn-rounded btn-primary" style="width: 150px;" @click="resetFilter">
                    Reset
                  </button>
                </div>
              </div>

              <div class="d-flex flex-column mt-2">
                <label><b>Total Outstanding Liability</b></label>
                <label>{{`$ ${activeClick ? active_outstanding : inactive_outstanding}`}}</label>
              </div>
            </div>

            <dy-table :tableHeader="header" :tableRows="rows" :tableFooter="footer" id="tbl_charity_active" :width="width"></dy-table>
          </div>
          <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import DyTable from "@/components/UI/Table";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "charity-view",
  components: { DyTable, Loading },

  data() {
    return {
      header: [
        "No.",
        "Name",
        "Banner",
        "Points Received",
        "Start Date",
        "End Date",
        "Paid",
        "Unpaid",
        "Status",
        "Action"
      ],
      active: [],
      inactive: [],
      rows: [],
      footer: [],
      width: ["5", "20", "20", "10", "10", "10", "10", "15"],

      tableTitle: "Active",
      active_src: [],
      inactive_src: [],
      activeClick: true,
      inactiveClick: false,

      active_outstanding: '',
      inactive_outstanding: '',
      active_sub_totals: null,
      inactive_sub_totals: null,

      filterData: {
        month_from: '',
        month_to: '',
        year_from: '',
        year_to: '',
      },

      months: [
        {value: 1, name: 'January'},
        {value: 2, name: 'February'},
        {value: 3, name: 'March'},
        {value: 4, name: 'April'},
        {value: 5, name: 'May'},
        {value: 6, name: 'June'},
        {value: 7, name: 'July'},
        {value: 8, name: 'August'},
        {value: 9, name: 'September'},
        {value: 10, name: 'October'},
        {value: 11, name: 'November'},
        {value: 12, name: 'December'},
      ],

      isLoading: false,

    };
  },

  methods: {
    async dataInitialize(request) {
      this.isLoading = true;
      await this.loadActive(request);
      await this.loadInActive(request);
      setTimeout(() => {
        this.insertActive();
      }, 100);

      setTimeout(() => {
        this.createDatatable();
      }, 100);

      this.isLoading = false;
    },

    async loadActive(additional_request = false) {
      let token = localStorage.getItem("token");

      const apiRequest = !additional_request ? `/charity/get?active=1` : `/charity/get?active=1&year_from=${this.filterData.year_from}&year_to=${this.filterData.year_to}&month_from=${this.filterData.month_from}&month_to=${this.filterData.month_to}` 

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        this.tableTitle = "Active";

        try {
          let result = await axios.get(axios.lpsURL + apiRequest, {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.active = result.data.charities;
          this.active_outstanding = result.data.outstanding;
          this.active_sub_totals = result.data.sub_totals;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async insertActive() {
      this.activeClick = true;
      this.inactiveClick = false;

      let count = 0;
      this.rows = [];
      this.footer = []
      this.tableTitle = "Active";

      for (let x = 0; x < this.active.length; x++) {
        count++;

        let res = await {
          index: count,
          name: this.active[x].name,
          banner: '<img src="' + this.active[x].banner + '">',
          points: parseInt(this.active[x].balance),
          startDate: this.active[x].start_at,
          endDate: this.active[x].end_at,
          paid: this.active[x].paid,
          unpaid: this.active[x].unpaid,
          status: this.checkActive(this.active[x].active),
          action: `<a href="/lps/charity/details/${this.active[x].id
            }" type="button" class="btn btn-primary btn-rounded btn-block">View Details</a>
          <a href="/lps/charity/redeem-list/${this.active[x].id
            }" type="button" class="btn btn-primary btn-rounded btn-block">Redeemed List</a>
          <a href="/lps/charity/report/${this.active[x].id
            }" type="button" class="btn btn-primary btn-rounded btn-block">View Report</a>`
        };

        this.rows.push(res);
      }

      this.footer = await {
        index: '',
        name: '',
        banner: 'Sub Total',
        points: this.active_sub_totals.total_points,
        startDate: '',
        endDate: '',
        paid: this.active_sub_totals.total_paid,
        unpaid: this.active_sub_totals.total_unpaid,
        status: '',
        action: '',
      }
    },

    async loadInActive(additional_request = false) {
      let token = localStorage.getItem("token");

      const apiRequest = !additional_request ? `/charity/get?active=0` : `/charity/get?active=0&year_from=${this.filterData.year_from}&year_to=${this.filterData.year_to}&month_from=${this.filterData.month_from}&month_to=${this.filterData.month_to}` 

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        let count = 0;
        try {
          let result = await axios.get(axios.lpsURL +apiRequest, {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.inactive = result.data.charities;
          this.inactive_outstanding = result.data.outstanding;
          this.inactive_sub_totals = result.data.sub_totals;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async insertInactive() {
      this.activeClick = false;
      this.inactiveClick = true;

      let count = 0;
      this.rows = [];
      this.footer = []
      this.tableTitle = "Inactive";

      for (let x = 0; x < this.inactive.length; x++) {
        count++;

        let res = await {
          index: count,
          name: this.inactive[x].name,
          banner: '<img src="' + this.inactive[x].banner + '">',
          points: parseInt(this.inactive[x].balance),
          startDate: this.inactive[x].start_at,
          endDate: this.inactive[x].end_at,
          paid: this.inactive[x].paid,
          unpaid: this.inactive[x].unpaid,
          status: this.checkActive(this.inactive[x].active),
          action: `<a href="/charity/details/${this.inactive[x].id
            }" type="button" class="btn btn-primary btn-rounded btn-block">View Details</a><a href="/charity/redeem-list/${this.inactive[x].id
            }" type="button" class="btn btn-primary btn-rounded btn-block">Redeemed List</a>
          <a href="/charity/report/${this.inactive[x].id
            }" type="button" class="btn btn-primary btn-rounded btn-block">View Report</a>`
        };

        this.rows.push(res);
      }

      this.footer = await {
        index: '',
        name: '',
        banner: 'Sub Total',
        points: this.inactive_sub_totals.total_points,
        startDate: '',
        endDate: '',
        paid: this.inactive_sub_totals.total_paid,
        unpaid: this.inactive_sub_totals.total_unpaid,
        status: '',
        action: '',
      }
    },

    checkActive(int) {
      switch (int) {
        case 1:
          return "Active";
        case 0:
          return "Inactive";
        default:
          return "Inactive";
      }
    },

    areAllFiltersFilled() {
      return Object.values(this.filterData).every(value => value !== '' && value !== null);
    },

    async filterPeriod() {
      if (!this.areAllFiltersFilled()) {
        swal({
          icon: 'error',
          text: 'Please enter all fields'
        });
        return; 
      }

      try {
        this.killDatatable();
        await this.dataInitialize(true)
      } catch (e) {
        console.error(e)
      }
    },

    async resetFilter() {
      this.killDatatable();
      await this.dataInitialize()
      this.resetFilteredData();
    },

    async resetFilteredData() {
      this.filterData = {
        month_from: '',
        month_to: '',
        year_from: '',
        year_to: ''
      };
    },

    async killDatatable() {
      $("#tbl_charity_active")
        .DataTable()
        .destroy();
    },

    async createDatatable() {
      $("#tbl_charity_active").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6, 7]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6, 7]
            }
          }
        ]
      });
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.dataInitialize();
  }
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}

.filter-buttons {
  align-self: end;
  justify-content: flex-end;
}

._filterClass{
  justify-content: space-between !important;
}
</style>
